import { sortBy } from "lodash";

import { UserRole, UserStatus } from "../../graphql/generated";
import { CurrentUser } from "../../types/user.ts";
import { toHumanReadable } from "../../utils/string.ts";
import { isBababosTenant } from "../../utils/user.ts";

export const userRoles = Object.values(UserRole).map((role) => ({
  value: role,
  label: toHumanReadable(role),
}));

export const getUserRoles = (user: CurrentUser | null | undefined) => {
  let options = [
    UserRole.Admin,
    UserRole.User,
    UserRole.CollectionOfficer,
    UserRole.CollectionManager,
  ];
  if (isBababosTenant(user)) {
    options = Object.values(UserRole).filter((role) => role !== UserRole.User);
  }
  return sortBy(
    options.map((role) => ({
      value: role,
      label: toHumanReadable(role),
    })),
    "label"
  );
};

export const userStatuses = Object.values(UserStatus).map((role) => ({
  value: role,
  label: toHumanReadable(role),
}));
